import { validateUrl } from "@lhd/features/Apps/utils";
import { Cell, CellStyle } from "@silevis/reactgrid";
import {
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
  keyCodes,
} from "@silevis/reactgrid";
import React from "react";

export interface CustomCell extends Cell {
  type: "custom";
  text: string;
  value?: number;
  nonEditable?: boolean;
  groupId?: number | string;
  style?: CellStyle;
  className?: string;
}

// CustomCellTemplate.tsx

export class CustomCellTemplate implements CellTemplate<CustomCell> {
  getCompatibleCell(
    uncertainCell: Uncertain<CustomCell>,
  ): Compatible<CustomCell> {
    return {
      ...uncertainCell,
      value: NaN,
      text: getCellProperty(uncertainCell, "text", "string"),
    };
  }

  renderCell(text: string) {
    const isLink = validateUrl(text);
    if (isLink)
      return (
        <a href={text} title={text} rel="noopener noreferrer" target="_blank">
          {text}
        </a>
      );
    if (!isNaN(Number(text))) {
      return (
        <div
          style={{
            textAlign: "right",
          }}
        >
          {text}
        </div>
      );
    }
    return text;
  }

  render(cell: Compatible<CustomCell>, isSelected: boolean): React.ReactNode {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        {this.renderCell(cell.text)}
      </div>
    );
  }
}
